import React from 'react';
import { DOM_ID_ADV_AUC_FULLSCREEN } from 'reactApp/appHelpers/featuresHelpers/features/advAucFullscreen';

import styles from './AdvFullscreenContainer.css';

export const AdvFullscreenContainer: React.FC = () => {
    return <div id={DOM_ID_ADV_AUC_FULLSCREEN} className={styles.container} />;
};
